import { __assign } from "tslib";
// DS: I11
import React from 'react';
import IconWrap from '../../IconWrap';
// this is used in shared/FaveButton/FavingIcon
export function getFavouriteIconMarkup(className) {
    return (React.createElement("path", { className: className, d: "M10.037 3.506L7.975 7.134l-4.57.641a1 1 0 00-.812.68l-.544 1.672a1 1 0 00.266 1.038l3.264 3.07-.765 4.33a1 1 0 00.416.997l1.566 1.081a1 1 0 001.022.069l4.035-2.052 4.116 2.07a1 1 0 001.024-.074l1.524-1.072a1 1 0 00.409-.999l-.8-4.35 3.257-3.063a1 1 0 00.261-1.052l-.564-1.65a1 1 0 00-.807-.666l-4.58-.643-2.066-3.653a1 1 0 00-.87-.508h-1.85a1 1 0 00-.87.506z" }));
}
var FavStarFill = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, getFavouriteIconMarkup()))); };
FavStarFill.displayName = 'FavStarFill';
export default FavStarFill;
//# sourceMappingURL=FavStarFill.js.map